import { render, staticRenderFns } from "./the-submenu.vue?vue&type=template&id=d5414bd4"
import script from "./the-submenu.vue?vue&type=script&lang=js"
export * from "./the-submenu.vue?vue&type=script&lang=js"
import style0 from "./the-submenu.vue?vue&type=style&index=0&id=d5414bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports